import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const first = document.getElementById("first-cta");
      if (!first) return;
      // Show once the first CTA has scrolled above the viewport
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-136" data-mp="38c0ifgozqie6">
      {visible && <motion.div initial={{
      y: 40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-ink/90 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:inset-x-auto md:bottom-6 md:right-6 md:bg-transparent md:p-0 md:backdrop-blur-0" data-id="element-137" data-mp="38cs5220m15sb">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-gold px-6 py-4 text-base font-extrabold uppercase tracking-wide text-ink shadow-[0_12px_30px_-8px_rgba(242,193,78,0.8)] ring-1 ring-gold-light focus:outline-none focus-visible:ring-4 md:w-auto" data-id="element-138" data-mp="2uapn6cjlxsa5">
            <span className="whitespace-nowrap" data-id="element-139" data-mp="26fd5884gp1jr">Get instant access · $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-140" data-mp="2bcwqvt3hoglq" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}